import React from 'react';
import { TableColumn } from '@hero/ui-kit/tables/Table';
import Tag from '@hero/ui-kit/components/Tag';
import P from '@hero/ui-kit/typography/P';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import { useLocation, useNavigate } from 'react-router-dom';
import type { Contact, MembershipStatus } from '../../types';
const NameRender: React.FC<{
    contact: Contact;
}> = ({ contact }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleClick = () => {
        const from = `${location.pathname}${location.search}`;
        navigate(`/mark/contacts/${contact.profile_id}`, { state: { from } });
    };
    return (
        <ClickableOpacity
            onClick={handleClick}
            alt="view-contact"
            styles={{
                cursor: 'pointer'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '0.4rem'
                }}
            >
                <P noDefaultMargin strong>
                    <span
                        style={{
                            borderBottom: '1px solid var(--mark-primary)'
                        }}
                    >
                        {contact.first_name} {contact.last_name}
                    </span>
                </P>
                <P
                    noDefaultMargin
                    size="small"
                    styles={{
                        borderBottom: '1px solid var(--mark-primary)'
                    }}
                >
                    {contact.email}
                </P>
            </div>
        </ClickableOpacity>
    );
};
const membershipTagType = (status: MembershipStatus) => {
    switch (status) {
        case 'ACTIVE':
            return 'success' as const;
        case 'PENDING':
            return 'warn' as const;
        case 'CANCELLED':
            return 'fail' as const;
    }
};
const getTableColumns = (): TableColumn<Contact>[] => [
    {
        colKey: 'name',
        name: 'Name',
        align: 'left',
        headAlign: 'left',
        render: (contact) => <NameRender contact={contact} />
    },
    {
        colKey: 'prospect_state',
        name: 'Status',
        align: 'left',
        headAlign: 'left',
        render: (contact) =>
            contact.prospect_state ? (
                <Tag
                    type={
                        contact.prospect_state === 'CONVERTED'
                            ? 'success'
                            : contact.prospect_state === 'STALE'
                              ? 'fail'
                              : 'primary'
                    }
                    size="small"
                >
                    {contact.prospect_state}
                </Tag>
            ) : (
                <P noDefaultMargin>—</P>
            )
    },
    {
        colKey: 'prospect_type',
        name: 'Type',
        align: 'left',
        headAlign: 'left',
        render: (contact) => <P noDefaultMargin>{contact.prospect_type || '—'}</P>
    },
    {
        colKey: 'membership_status',
        name: 'Membership',
        align: 'left',
        headAlign: 'left',
        render: (contact) =>
            contact.membership_status ? (
                <Tag type={membershipTagType(contact.membership_status)} size="small">
                    {contact.membership_status}
                </Tag>
            ) : (
                <P noDefaultMargin>—</P>
            )
    },
    {
        colKey: 'suppressed',
        name: 'Suppressed',
        align: 'left',
        headAlign: 'left',
        render: (contact) =>
            contact.suppressed ? (
                <Tag type="fail" size="small">
                    Suppressed
                </Tag>
            ) : null
    }
];
export default getTableColumns;
